import { Package } from 'lucide-react'
import { EntityCard } from '#app/routes/mocra+/_form+/components/entity-card.tsx'
import {
	formatSupplierSummary,
	supplierCardTitle,
	type SupplierDraft,
} from '#app/routes/mocra+/_form+/components/suppliers/types.ts'

type Props = {
	readonly index: number
	readonly supplier: SupplierDraft
	readonly onEdit: () => void
	readonly onRemove?: () => void
	readonly removeDisabled?: boolean
	readonly errors?: readonly string[]
}

export function SupplierCard({
	index,
	supplier,
	onEdit,
	onRemove,
	removeDisabled,
	errors,
}: Props) {
	const title = supplierCardTitle(supplier, index)
	const description = formatSupplierSummary(supplier)
	const hasErrors = Boolean(errors && errors.length > 0)

	return (
		<EntityCard
			title={title}
			description={hasErrors ? `${description} • Needs attention` : description}
			onEdit={onEdit}
			onRemove={onRemove}
			removeDisabled={removeDisabled}
			removeLabel="Remove"
			removeConfirmTitle="Remove this supplier?"
			removeConfirmDescription="This supplier will be removed from the list."
			icon={
				<Package
					className="text-muted-foreground h-3.5 w-3.5"
					aria-hidden="true"
				/>
			}
			className={
				hasErrors
					? 'border-destructive/40 ring-destructive/40 ring-1'
					: undefined
			}
		/>
	)
}
